(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/selectors/assets/javascripts/select-draws.js') >= 0) return;  svs.modules.push('/components/tipsen/selectors/assets/javascripts/select-draws.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _RTK = RTK,
  createSelector = _RTK.createSelector;
const selectDrawProductIds = svs.components.tipsen.engine.selectors.engineSelectors.selectDrawProductIds;
const selectAll = svs.components.sport.drawsRedux.globalizedSelectors.selectAll;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectBetEvents = _svs$components$sport.selectBetEvents,
  selectSportEvents = _svs$components$sport.selectSportEvents,
  selectLeagues = _svs$components$sport.selectLeagues;
const DrawState = svs.components.sport.tipsenShared.DrawState;
const selectAllDraws = state => state.Draws || {
  entities: {}
};
const makeSelectDrawsByDrawNumber = (productId, drawNumbers) => createSelector(selectAllDraws, draws => drawNumbers.map(drawNumber => draws.entities["".concat(productId, "_").concat(drawNumber)]));
const selectDrawsByProduct = createSelector([selectDrawProductIds, selectAll], (productIds, draws) => draws.filter(draw => productIds.includes(draw.productId)));
const selectCurrentDrawsByProduct = createSelector([selectDrawProductIds, selectAll], (productIds, draws) => {
  const validStates = [DrawState.Defined, DrawState.Opened];
  return draws.filter(draw => !draws.isLite && productIds.includes(draw.productId) && validStates.includes(draw.drawStateId)).filter(v => v).sort((a, b) => b.drawStateId - a.drawStateId);
});
const makeSelectBetEventsFromDraw = productDrawId => createSelector(selectAllDraws, selectBetEvents, (draws, betEvents) => {
  const draw = draws.entities[productDrawId] || {
    drawEvents: []
  };
  const productId = draw.productId,
    drawNumber = draw.drawNumber;
  return draw.drawEvents.map(_ref => {
    let eventNumber = _ref.eventNumber;
    return betEvents["".concat(productId, "_").concat(drawNumber, "_").concat(eventNumber)];
  });
});
const makeSelectLeaguesFromDraw = productDrawId => createSelector(selectSportEvents, selectAllDraws, selectLeagues, (sportEvents, draws, leagues) => {
  const draw = draws.entities[productDrawId] || {
    drawEvents: []
  };
  return draw.drawEvents.map(_ref2 => {
    let matchId = _ref2.matchId;
    if (matchId && sportEvents[matchId]) {
      var _sportEvents$matchId;
      return leagues[(_sportEvents$matchId = sportEvents[matchId]) === null || _sportEvents$matchId === void 0 ? void 0 : _sportEvents$matchId.leagueId];
    }
    return undefined;
  }).filter(Boolean);
});
const makeSelectLeaguesAccumulatedFromDraw = productDrawId => createSelector(makeSelectLeaguesFromDraw(productDrawId), leagues => Object.entries(
leagues.reduce((leagueReducer, _ref3) => {
  var _leagueReducer$id$ord, _leagueReducer$id, _leagueReducer$id2;
  let id = _ref3.id,
    uniqueLeagueName = _ref3.uniqueLeagueName,
    name = _ref3.name;
  const currentOrder = (_leagueReducer$id$ord = (_leagueReducer$id = leagueReducer[id]) === null || _leagueReducer$id === void 0 ? void 0 : _leagueReducer$id.order) !== null && _leagueReducer$id$ord !== void 0 ? _leagueReducer$id$ord : Object.keys(leagueReducer).length + 1;
  return _objectSpread(_objectSpread({}, leagueReducer), {}, {
    [id]: {
      id,
      name,
      uniqueLeagueName,
      occurrences: ((_leagueReducer$id2 = leagueReducer[id]) !== null && _leagueReducer$id2 !== void 0 ? _leagueReducer$id2 : 0) + 1,
      order: currentOrder
    }
  });
}, {})).map(_ref4 => {
  let _ref5 = _slicedToArray(_ref4, 2),
    key = _ref5[0],
    data = _ref5[1];
  return _objectSpread({
    key
  }, data);
}).sort((a, b) => a.order - b.order));
const makeSelectBetEventParticipantsFromDraw = (productId, drawNumber) => createSelector(makeSelectBetEventsFromDraw("".concat(productId, "_").concat(drawNumber)), state => state.Participants, (betEvents, participants) => {
  if (!productId || !drawNumber || !betEvents) {
    return [];
  }
  return betEvents.map(event => _objectSpread(_objectSpread({}, event), {}, {
    homeTeam: participants[event.participants[0]],
    awayTeam: participants[event.participants[1]]
  }));
});
setGlobal('svs.components.tipsen.selectors', {
  selectAllDraws,
  selectDrawsByProduct,
  selectCurrentDrawsByProduct,
  makeSelectBetEventsFromDraw,
  makeSelectLeaguesFromDraw,
  makeSelectLeaguesAccumulatedFromDraw,
  makeSelectDrawsByDrawNumber,
  makeSelectBetEventParticipantsFromDraw
});

 })(window);